export default String.raw`
<g id="Tekst SEO/mobile" class="textElementFont">
    <g id="Tekst SEO">
        <rect width="360" height="360" class="textElementBg"/>
        <g id="4. Text Button" class="iconColors">
            <text id="Text" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="16.3262" y="321.091">TRANSLATION_Prv_RollOutDescription</tspan></text>
            <g id="Arrows/chevron down" transform="translate(108, 310)">
                <use href="#chevron-down" width="12" height="12"></use>
            </g>
        </g>
        <g id="Zawartosc" clip-path="url(#clip1_2076_723935)">
            <rect width="328" height="256" transform="translate(16 32)" class="textElementBg"/>
            <g id="kolumna 1 ">
                <text xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="16" y="50.5455">TRANSLATION_Prv_CategoryDesc_Title</tspan></text>
                <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="16" y="87.0909">TRANSLATION_Prv_CategoryDesc_Mobile_LineOne </tspan><tspan x="16" y="107.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineTwo </tspan><tspan x="16" y="127.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineThree </tspan><tspan x="16" y="147.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineFour </tspan><tspan x="16" y="167.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineFive </tspan><tspan x="16" y="187.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineSix </tspan><tspan x="16" y="207.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineSeven</tspan><tspan x="16" y="207.091">&#x2028;</tspan><tspan x="16" y="247.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineEight </tspan><tspan x="16" y="267.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineNine </tspan><tspan x="16" y="287.091">TRANSLATION_Prv_CategoryDesc_Mobile_LineTen</tspan></text>
            </g>
            <g id="shade">
                <rect width="216" height="1441" transform="matrix(0 1 -1 0 1327 144)" fill="url(#paint0_linear_2076_723935)"/>
            </g>
        </g>
    </g>
</g>
<defs>
    <linearGradient id="paint0_linear_2076_723935" x1="216" y1="720.5" x2="-4.43419e-06" y2="720.5" gradientUnits="userSpaceOnUse">
        <stop class="textElementBg--stop"/>
        <stop offset="1" class="textElementBg--stop" stop-opacity="0"/>
    </linearGradient>
    <clipPath id="clip1_2076_723935">
        <rect width="328" height="256" transform="translate(16 32)"/>
    </clipPath>
</defs>
`;